import { useState, useEffect } from 'react';
import CompanyRepo from '../utils/repository/companyRepo';
import { CompanyType } from '../types/company.types';

const useCompanies = (params:any = {}) => {
    const [companies, setCompanies] = useState<CompanyType[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        CompanyRepo.listInternal(params,(companies: CompanyType[]) => {
            setCompanies(companies);
            setLoading(false);
        });
    }, []);

    return { companies, loading };
};

export default useCompanies;
